import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from 'i18n/en/index.json';
import zhTranslation from 'i18n/zh/index.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  'zh-Hant': {
    translation: zhTranslation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
